export enum LANGUAGE {
  EN = 'en',
  JA = 'ja',
}
